import React, { Component } from 'react';
import { Col, Modal, Row } from 'antd';
import { fetchData } from '../../../lib/apis';
import OrderSummaryCard from './components/OrderSummaryCard';
import OrderCustomerCard from './components/OrderCustomerCard';
import OrderItemsCard from './components/OrderItemsCard';
import OrderPricingCard from './components/OrderPricingCard';
import OrderTimeline from './components/OrderTimeline';
import OrderAssignmentBar from './components/OrderAssignmentBar';
import OrderActionBar from './components/OrderActionBar';
import OrderShipmentSummaryCard from './components/OrderShipmentSummaryCard';
import OrderShipmentCreateDrawer from './components/OrderShipmentCreateDrawer';
import OrderShipmentTimeline from './components/OrderShipmentTimeline';

export default class OrderDetailView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            order: null,
            note: '',
            assigneeOptions: [],
            selectedAssigneeId: '',
            shipmentDetail: null,
            shipmentEvents: [],
            shipmentDrawerVisible: false,
            shipmentServiceOptions: [],
            shipmentFeeQuote: null,
            shipmentProviderSelected: '',
            shipmentPrintFormat: 'a5',
            viettelProvinces: [],
            viettelWards: [],
            saving: false
        };
    }

    componentDidMount() {
        this.loadAssigneeOptions();
        this.loadOrderDetail();
    }

    loadAssigneeOptions = async () => {
        try {
            const response = await fetchData({ url: 'api/v2/staff/list' });
            const data = Array.isArray(response.data) ? response.data : [];
            this.setState({
                assigneeOptions: data.map((item) => ({
                    user_id: `${item.id_user_vnp_sw || item.user_id || ''}`.trim(),
                    name: item.user_name_vnp_sw || item.full_name || item.name || `${item.id_user_vnp_sw || item.user_id || ''}`.trim()
                })).filter((item) => item.user_id)
            });
        } catch (err) {
            this.setState({ assigneeOptions: [] });
        }
    }

    loadShipmentDetail = async (orderId) => {
        try {
            const response = await fetchData({ url: `api/v1/shipments/order/${orderId}` });
            this.setState({
                shipmentDetail: response.data ? response.data.shipment || null : null,
                shipmentEvents: response.data ? response.data.events || [] : []
            });
        } catch (err) {
            this.setState({ shipmentDetail: null, shipmentEvents: [] });
        }
    }

    loadOrderDetail = async () => {
        try {
            this.setState({ loading: true });
            const response = await fetchData({ url: `api/v1/orders-v2/${this.props.match.params.id}` });
            const order = response.data || null;
            this.setState({
                loading: false,
                order,
                note: order && order.notes ? order.notes.internal || '' : '',
                selectedAssigneeId: order && order.assignee ? order.assignee.user_id || '' : ''
            });
            await this.loadShipmentDetail(order ? order._id : '');
        } catch (err) {
            this.setState({ loading: false });
            this.props.notification({
                title: 'Đơn hàng',
                content: err.message || 'Không thể tải chi tiết đơn hàng',
                type: 'error'
            });
        }
    }

    handleShipmentProviderChange = (provider) => {
        this.setState({
            shipmentProviderSelected: provider,
            shipmentServiceOptions: [],
            shipmentFeeQuote: null
        });
    }

    loadViettelWards = async (provinceId) => {
        if (!provinceId) {
            this.setState({ viettelWards: [] });
            return [];
        }
        const response = await fetchData({
            url: `api/v1/addresses/wards?province_id=${encodeURIComponent(provinceId)}`
        });
        const wards = Array.isArray(response.data) ? response.data : [];
        this.setState({ viettelWards: wards });
        return wards;
    }

    loadViettelLocations = async () => {
        try {
            const provinceResponse = await fetchData({ url: 'api/v1/addresses/provinces' });
            const provinces = Array.isArray(provinceResponse.data) ? provinceResponse.data : [];
            const orderProvinceId = this.state.order && this.state.order.customer && this.state.order.customer.province
                ? this.state.order.customer.province.id || ''
                : '';
            const selectedProvinceId = orderProvinceId || (provinces[0] && provinces[0].id) || '';
            this.setState({ viettelProvinces: provinces });
            await this.loadViettelWards(selectedProvinceId);
        } catch (err) {
            this.setState({ viettelProvinces: [], viettelWards: [] });
            this.props.notification({
                title: 'Shipment',
                content: err.message || 'Không lấy được danh mục Viettel',
                type: 'error'
            });
        }
    }

    handleShipmentProvinceChange = async (provinceId) => {
        try {
            await this.loadViettelWards(provinceId);
        } catch (err) {
            this.setState({ viettelWards: [] });
            this.props.notification({
                title: 'Shipment',
                content: err.message || 'Không lấy được danh sách Phường/Xã',
                type: 'error'
            });
        }
    }

    openShipmentDrawer = () => {
        this.setState({ shipmentDrawerVisible: true }, this.loadViettelLocations);
    }

    loadViettelQuote = async (shipmentValues = {}) => {
        const order = this.state.order;
        if (!order) return;
        try {
            const serviceResponse = await fetchData({
                url: 'api/v1/logistics-integrations/viettel/services',
                method: 'post',
                data: {
                    RECEIVER_PROVINCE: shipmentValues.province_id || (order.customer && order.customer.province ? order.customer.province.id || 0 : 0),
                    RECEIVER_DISTRICT: null,
                    RECEIVER_WARD: shipmentValues.ward_id || (order.customer && order.customer.ward ? order.customer.ward.id || 0 : 0),
                    PRODUCT_TYPE: 'HH',
                    PRODUCT_WEIGHT: 0,
                    PRODUCT_PRICE: order.pricing ? order.pricing.grand_total || 0 : 0,
                    MONEY_COLLECTION: order.pricing ? order.pricing.grand_total || 0 : 0,
                    TYPE: 1,
                    PRODUCT_LENGTH: 0,
                    PRODUCT_WIDTH: 0,
                    PRODUCT_HEIGHT: 0,
                    SENDER_PROVINCE: 0,
                    SENDER_DISTRICT: 0,
                    SENDER_WARD: 0
                }
            });
            const options = Array.isArray(serviceResponse.data) ? serviceResponse.data : (serviceResponse.data && serviceResponse.data.data) || [];
            this.setState({ shipmentServiceOptions: options });

            if (options.length > 0) {
                const firstService = options[0].MA_DV_CHINH || '';
                const feeResponse = await fetchData({
                    url: 'api/v1/logistics-integrations/viettel/fee',
                    method: 'post',
                    data: {
                        RECEIVER_PROVINCE: shipmentValues.province_id || (order.customer && order.customer.province ? order.customer.province.id || 0 : 0),
                        RECEIVER_DISTRICT: null,
                        RECEIVER_WARD: shipmentValues.ward_id || (order.customer && order.customer.ward ? order.customer.ward.id || 0 : 0),
                        PRODUCT_TYPE: 'HH',
                        PRODUCT_WEIGHT: 0,
                        PRODUCT_PRICE: order.pricing ? order.pricing.grand_total || 0 : 0,
                        MONEY_COLLECTION: order.pricing ? order.pricing.grand_total || 0 : 0,
                        NATIONAL_TYPE: 1,
                        PRODUCT_LENGTH: 0,
                        PRODUCT_WIDTH: 0,
                        PRODUCT_HEIGHT: 0,
                        ORDER_SERVICE: firstService,
                        ORDER_SERVICE_ADD: '',
                        SENDER_PROVINCE: 0,
                        SENDER_DISTRICT: 0,
                        SENDER_WARD: 0
                    }
                });
                this.setState({ shipmentFeeQuote: feeResponse.data && feeResponse.data.data ? feeResponse.data.data : feeResponse.data || null });
            }
        } catch (err) {
            this.props.notification({
                title: 'Shipment',
                content: err.message || 'Không lấy được dịch vụ/cước Viettel',
                type: 'error'
            });
        }
    }

    printViettelLabel = async () => {
        const shipment = this.state.shipmentDetail;
        if (!shipment || !shipment.provider_order_code) return;
        try {
            const response = await fetchData({
                url: 'api/v1/logistics-integrations/viettel/print',
                method: 'post',
                data: {
                    EXPIRY_TIME: Date.now() + 3600000,
                    ORDER_ARRAY: [shipment.provider_order_code]
                }
            });
            const links = response.data && response.data.data ? response.data.data.links || {} : {};
            const format = this.state.shipmentPrintFormat || 'a5';
            if (links[format]) window.open(links[format], '_blank');
        } catch (err) {
            this.props.notification({
                title: 'Shipment',
                content: err.message || 'Không lấy được link in vận đơn',
                type: 'error'
            });
        }
    }

    updateViettelShipment = async () => {
        const shipment = this.state.shipmentDetail;
        if (!shipment || !shipment.provider_order_code) return;
        try {
            await fetchData({
                url: 'api/v1/logistics-integrations/viettel/order/update',
                method: 'post',
                data: {
                    ORDER_NUMBER: shipment.provider_order_code,
                    SENDER_FULLNAME: 'CRM',
                    SENDER_PHONE: '',
                    SENDER_ADDRESS: '',
                    RECEIVER_FULLNAME: this.state.order && this.state.order.customer ? this.state.order.customer.name || '' : '',
                    RECEIVER_PHONE: this.state.order && this.state.order.customer ? this.state.order.customer.phone || '' : '',
                    RECEIVER_ADDRESS: this.state.order && this.state.order.customer ? this.state.order.customer.address_line || '' : ''
                }
            });
            this.props.notification({ title: 'Shipment', content: 'Đã gửi yêu cầu cập nhật Viettel', type: 'success' });
        } catch (err) {
            this.props.notification({ title: 'Shipment', content: err.message || 'Cập nhật Viettel thất bại', type: 'error' });
        }
    }

    cancelViettelShipment = async () => {
        const shipment = this.state.shipmentDetail;
        if (!shipment || !shipment.provider_order_code) return;
        try {
            await fetchData({
                url: 'api/v1/logistics-integrations/viettel/order/status',
                method: 'post',
                data: {
                    TYPE: 4,
                    ORDER_NUMBER: shipment.provider_order_code,
                    NOTE: 'Hủy từ CRM'
                }
            });
            this.props.notification({ title: 'Shipment', content: 'Đã gửi yêu cầu hủy Viettel', type: 'success' });
        } catch (err) {
            this.props.notification({ title: 'Shipment', content: err.message || 'Hủy Viettel thất bại', type: 'error' });
        }
    }

    confirmViettelUpdate = () => {
        Modal.confirm({
            title: 'Cập nhật vận đơn Viettel?',
            content: 'Thao tác này sẽ gọi API cập nhật đơn Viettel.',
            onOk: this.updateViettelShipment
        });
    }

    confirmViettelCancel = () => {
        Modal.confirm({
            title: 'Hủy vận đơn Viettel?',
            content: 'Thao tác này sẽ gọi API hủy đơn phía Viettel.',
            okType: 'danger',
            onOk: this.cancelViettelShipment
        });
    }

    createShipment = async (values) => {
        const order = this.state.order;
        if (!order) return;

        const route = values.provider === 'ghn' ? 'api/v1/shipments/ghn/create' : 'api/v1/shipments/viettel/create';
        try {
            this.setState({ saving: true });
            await fetchData({
                url: route,
                method: 'post',
                data: {
                    order_id: order._id,
                    recipient_name: values.recipient_name,
                    phone: values.phone,
                    address_line: values.address_line,
                    province_id: values.province_id,
                    ward_id: values.ward_id,
                    cod_amount: values.cod_amount,
                    delivery_note: values.delivery_note,
                    service_code: values.service_code || '',
                    extra_service_code: values.extra_service_code || ''
                }
            });
            this.setState({ saving: false, shipmentDrawerVisible: false });
            await this.loadOrderDetail();
        } catch (err) {
            this.setState({ saving: false });
            this.props.notification({
                title: 'Shipment',
                content: err.message || 'Tạo shipment thất bại',
                type: 'error'
            });
        }
    }

    callOrderAction = async (request) => {
        try {
            this.setState({ saving: true });
            await fetchData(request);
            this.setState({ saving: false });
            await this.loadOrderDetail();
        } catch (err) {
            this.setState({ saving: false });
            this.props.notification({
                title: 'Đơn hàng',
                content: err.message || 'Thao tác thất bại',
                type: 'error'
            });
        }
    }

    render() {
        const order = this.state.order;
        if (!order) return <div>Đang tải...</div>;
        const flags = order.permission_flags || {};

        return (
            <div className="content-m list-h">
                <div className="list-c list-m">
                    <Row gutter={16}>
                        <Col span={16}>
                            <OrderSummaryCard order={order} />
                            <OrderCustomerCard
                                order={order}
                                onOpenChat={() => {
                                    const contactId = order.related_refs ? order.related_refs.contact_id : '';
                                    if (contactId) this.props.history.push(`/chat/${contactId}#info`);
                                }}
                            />
                            <OrderItemsCard order={order} />
                            <OrderPricingCard order={order} />
                        </Col>
                        <Col span={8}>
                            <OrderShipmentSummaryCard
                                shipmentSummary={order.shipment_summary || {}}
                                shipmentActions={order.shipment_actions || {}}
                                shipmentLockState={order.shipment_lock_state || {}}
                                onOpenCreateDrawer={this.openShipmentDrawer}
                                onPrintLabel={this.printViettelLabel}
                                printFormat={this.state.shipmentPrintFormat}
                                onPrintFormatChange={(value) => this.setState({ shipmentPrintFormat: value })}
                                onViettelUpdate={this.confirmViettelUpdate}
                                onViettelCancel={this.confirmViettelCancel}
                            />
                            <OrderAssignmentBar
                                order={order}
                                assigneeOptions={this.state.assigneeOptions}
                                selectedAssigneeId={this.state.selectedAssigneeId}
                                canAssign={flags.can_assign}
                                canReassign={flags.can_reassign}
                                onAssigneeChange={(value) => this.setState({ selectedAssigneeId: value })}
                                onAssign={() => this.callOrderAction({
                                    url: `api/v1/orders-v2/${order._id}/assign`,
                                    method: 'post',
                                    data: { assignee_id: this.state.selectedAssigneeId || '' }
                                })}
                                onReassign={() => this.callOrderAction({
                                    url: `api/v1/orders-v2/${order._id}/reassign`,
                                    method: 'post',
                                    data: { assignee_id: this.state.selectedAssigneeId || '' }
                                })}
                            />
                            <OrderActionBar
                                order={order}
                                note={this.state.note}
                                saving={this.state.saving}
                                canEdit={flags.can_edit}
                                canConfirm={flags.can_confirm}
                                canCancel={flags.can_cancel}
                                isReadOnly={flags.is_read_only}
                                onNoteChange={(value) => this.setState({ note: value })}
                                onSaveNote={() => this.callOrderAction({
                                    url: `api/v1/orders-v2/${order._id}/note`,
                                    method: 'put',
                                    data: { note: this.state.note }
                                })}
                                onSaveDraft={() => this.callOrderAction({
                                    url: `api/v1/orders-v2/${order._id}`,
                                    method: 'put',
                                    data: {
                                        customer: order.customer,
                                        items: (order.items || []).map((item) => ({
                                            variant_id: item.variant_id,
                                            quantity: item.quantity,
                                            image: item.variant_snapshot ? item.variant_snapshot.image || '' : ''
                                        })),
                                        discount: order.pricing ? order.pricing.discount || 0 : 0,
                                        shipping_fee: order.pricing ? order.pricing.shipping_fee || 0 : 0,
                                        notes: { internal: this.state.note }
                                    }
                                })}
                                onConfirm={() => this.callOrderAction({
                                    url: 'api/v1/orders-v2/confirm',
                                    method: 'post',
                                    data: {
                                        order_id: order._id,
                                        customer: order.customer,
                                        items: (order.items || []).map((item) => ({
                                            variant_id: item.variant_id,
                                            quantity: item.quantity,
                                            image: item.variant_snapshot ? item.variant_snapshot.image || '' : ''
                                        })),
                                        discount: order.pricing ? order.pricing.discount || 0 : 0,
                                        shipping_fee: order.pricing ? order.pricing.shipping_fee || 0 : 0,
                                        notes: { internal: this.state.note },
                                        source: { contact_id: order.related_refs ? order.related_refs.contact_id : '' }
                                    }
                                })}
                                onCancel={() => this.callOrderAction({
                                    url: `api/v1/orders-v2/${order._id}/cancel`,
                                    method: 'post',
                                    data: { reason: this.state.note }
                                })}
                            />
                            <OrderShipmentTimeline events={this.state.shipmentEvents} />
                            <OrderTimeline history={order.history || []} />
                        </Col>
                    </Row>
                    <OrderShipmentCreateDrawer
                        visible={this.state.shipmentDrawerVisible}
                        onClose={() => this.setState({ shipmentDrawerVisible: false })}
                        onSubmit={this.createShipment}
                        availableProviders={order.shipment_actions ? order.shipment_actions.available_providers || [] : []}
                        order={order}
                        saving={this.state.saving}
                        serviceOptions={this.state.shipmentServiceOptions}
                        feeQuote={this.state.shipmentFeeQuote}
                        viettelProvinces={this.state.viettelProvinces}
                        viettelWards={this.state.viettelWards}
                        onProviderChange={this.handleShipmentProviderChange}
                        onLoadViettelQuote={this.loadViettelQuote}
                        onLoadViettelLocations={this.loadViettelLocations}
                        onProvinceChange={this.handleShipmentProvinceChange}
                    />
                </div>
            </div>
        );
    }
}
